const common = {
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.about": "About Us",
  "nav.pricing": "Pricing",
  "nav.testimonials": "Reviews",
  "nav.contact": "Contact",
  "nav.booking": "Appointment",
  "nav.gallery": "Gallery",
  "nav.team": "Team",

  "hero.title_line1": "Your Beauty.",
  "hero.title_line2": "Our Art.",
  "hero.subtitle": "Premium dentistry in a luxurious atmosphere. Internationally acclaimed experts for your new smile – up to 70% cheaper than in Germany/Austria/Switzerland.",
  "hero.cta": "Book an Appointment",
  "hero.badge": "PREMIUM CLINIC TIRANA · UP TO 70% CHEAPER THAN IN DE/AT/CH",
  "hero.stat1.value": "7,500+",
  "hero.stat1.label": "Patients",
  "hero.stat2.value": "15",
  "hero.stat2.label": "Years Experience",
  "hero.stat3.value": "98%",
  "hero.stat3.label": "Satisfaction",

  "services.tag": "OUR SERVICES",
  "services.heading": "Excellence in Every Treatment",
  "services.dental.title": "Dentistry",
  "services.dental.desc": "Dental implants, veneers, zirconia crowns, whitening and more. Premium prosthetics with state-of-the-art 3D diagnostics – up to 70% cheaper than in Germany.",
  "services.dental.count": "12 Treatments",
  "services.surgery.title": "Plastic Surgery",
  "services.surgery.desc": "Facelift, rhinoplasty, breast augmentation, liposuction and more. Highest safety standards with hotel & transfer included.",
  "services.surgery.count": "21 Procedures",
  "services.hair.title": "Hair Transplant",
  "services.hair.desc": "FUE hair transplant with state-of-the-art micropunch technique. Up to 5,000 grafts – completely scar-free, naturally dense results. Free hair analysis included.",
  "services.hair.count": "1 Treatment",
  "services.cta": "Discover All Services",

  "about.tag": "OUR HOME",
  "about.heading_line1": "Beauty, born in",
  "about.heading_line2": "Albania.",
  "about.description": "In the heart of Tirana, Albania's vibrant capital, Esteva Clinic was born from a vision: to unite world-class aesthetics with the warmth of Mediterranean hospitality. Albania — a country of breathtaking beauty, from the turquoise waters of the Adriatic to the majestic peaks of the Albanian Alps — is experiencing a spectacular renaissance. As the country grows rapidly into one of Europe's most sought-after destinations, we have created a place in Tirana where international medical excellence meets the authentic feeling of being truly welcome. Our clinic reflects the spirit of Albania: young, ambitious, full of heart — and ready to take on the world.",
  "about.quote": "Albania taught me that true beauty is born from authenticity. Here, between mountains and sea, we grow together — the country, our team, and every single person who walks through our doors.",
  "about.name": "Dr. Nertila Basha",
  "about.position": "CEO, Dentist, Implantologist & Prosthodontist",

  "pricing.tag": "PRICE PACKAGES",
  "pricing.heading_line1": "Transparent",
  "pricing.heading_line2": "Excellence.",
  "pricing.subtitle": "Every package tailored to your needs. No hidden costs, no compromises.",
  "pricing.basic.title": "Essential",
  "pricing.basic.price": "from €1,490",
  "pricing.basic.feature1": "Initial Consultation & Analysis",
  "pricing.basic.feature2": "1 Treatment of Choice",
  "pricing.basic.feature3": "Aftercare Package Basic",
  "pricing.premium.title": "Premium",
  "pricing.premium.price": "from €3,990",
  "pricing.premium.feature1": "VIP Initial Consultation",
  "pricing.premium.feature2": "2 Combined Treatments",
  "pricing.premium.feature3": "Premium Aftercare & Care Products",
  "pricing.luxe.title": "Luxe",
  "pricing.luxe.price": "from €7,490",
  "pricing.luxe.feature1": "Personal Beauty Concierge",
  "pricing.luxe.feature2": "3 Treatments + Hotel Package",
  "pricing.luxe.feature3": "1 Year Aftercare & Guarantee",
  "pricing.exclusive.title": "Exclusif",
  "pricing.exclusive.price": "Custom",
  "pricing.exclusive.feature1": "Complete Transformation",
  "pricing.exclusive.feature2": "All Treatments Included",
  "pricing.exclusive.feature3": "Lifetime Aftercare",
  "pricing.dental_title": "DENTAL PRICE LIST",
  "pricing.surgery_title": "PLASTIC SURGERY PRICE LIST",
  "pricing.hair_title": "HAIR TRANSPLANT PRICE LIST",
  "pricing.included_title": "Included Services",
  "pricing.included_over_3000": "For estimates over €3,000: hotel, taxi, airline ticket, and 3D mouth scan are included.",
  "pricing.included_over_1500": "For estimates over €1,500: hotel, taxi, and 3D mouth scan are included.",
  "pricing.table_service": "SERVICE",
  "pricing.table_price": "PRICE (EUR)",
  "pricing.table_stay": "HOSPITAL & HOTEL STAY",
  "pricing.table_total": "TOTAL",
  "pricing.note_individual": "Individual prices may vary based on the complexity of the procedure. A detailed quote will be provided during your consultation.",
  "pricing.cta": "Book a Consultation",
  "instagram.tag": "FOLLOW US",
  "instagram.heading": "Glimpses of Excellence.",
  "instagram.subtitle": "Join us on Instagram for exclusive insights, before-and-after moments, and the latest trends in aesthetic medicine.",
  "instagram.cta": "Follow @estevaclinic",

  "testimonials.tag": "TESTIMONIALS",
  "testimonials.heading": "What Our Clients Say",

  "booking.tag": "BOOKING",
  "booking.heading_line1": "Your journey begins",
  "booking.heading_line2": "with a conversation.",
  "booking.description": "Book your personal consultation now. Our experts take time for your individual wishes and create a tailored treatment concept – discreet and confidential.",
  "booking.cta": "Book Appointment",
  "booking.hero_subtitle": "Choose your preferred date and time. Our team will get back to you within 24 hours with a confirmation.",
  "booking.select_date_hint": "Please select a date first to view available time slots.",
  "booking.your_data": "Your Details",
  "booking.form_subtitle": "Fill out the form to finalize your appointment.",
  "booking.firstname": "First Name *",
  "booking.firstname_placeholder": "First name",
  "booking.lastname": "Last Name *",
  "booking.lastname_placeholder": "Last name",
  "booking.email": "Email *",
  "booking.email_placeholder": "your@email.com",
  "booking.phone": "Phone *",
  "booking.phone_placeholder": "+1 234 5678900",
  "booking.service_label": "Desired Treatment *",
  "booking.service_placeholder": "Please select",
  "booking.service_combined": "Combined Treatment",
  "booking.service_consultation": "Consultation",
  "booking.package_label": "Desired Package",
  "booking.package_undecided": "Still undecided",
  "booking.package_essential": "Essential – from €1,490",
  "booking.package_premium": "Premium – from €3,990",
  "booking.package_luxe": "Luxe – from €7,490",
  "booking.package_exclusif": "Exclusif – Custom",
  "booking.message_label": "Special Requests or Notes",
  "booking.message_placeholder": "Let us know what we should pay special attention to...",
  "booking.max_chars": "Max. 500 characters",
  "booking.privacy_consent": "I agree that my data will be stored and processed for appointment scheduling. I have read the privacy policy.",
  "booking.select_datetime_warning": "Please select a date and time to complete the booking.",
  "booking.success_title": "Thank you for your booking!",
  "booking.success_message": "We will get back to you within 24 hours.",
  "booking.time_label": "Select Time",
  "booking.time_selected": "Selected:",
  "booking.time_unit": "o'clock",

  "footer.tagline": "Esteva Clinic – Where beauty becomes art.",
  "footer.services": "Services",
  "footer.about": "About",
  "footer.legal": "Legal",
  "footer.contact": "Contact",
  "footer.hair": "Dentistry",
  "footer.dental": "Dentistry",
  "footer.surgery": "Plastic Surgery",
  "footer.botox": "Plastic Surgery",
  "footer.team": "Our Team",
  "footer.philosophy": "Philosophy",
  "footer.career": "Career",
  "footer.press": "Press",
  "footer.imprint": "Imprint",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms & Conditions",
  "footer.faq": "FAQ",
  "footer.newsletter_title": "Stay Inspired.",
  "footer.newsletter_subtitle": "Exclusive insights, new treatments, and special offers straight to your inbox.",
  "footer.newsletter_placeholder": "Your email address",
  "footer.newsletter_button": "Subscribe",
  "footer.copyright": "© 2026 Esteva Clinic. All rights reserved.",
  "footer.seo_text": "Esteva Clinic is your premium beauty and dental clinic in Tirana, Albania. We offer dental implants, zirconia crowns, veneers, hair transplantation (FUE), breast augmentation, rhinoplasty, facelift, Botox, liposuction and plastic surgery up to 70% cheaper than in Switzerland, Germany and Austria. Patients from Zurich, Basel, Bern, Vienna, Munich and Berlin trust Esteva Clinic. Free initial consultation — book your appointment now.",

  "language.de": "DE",
  "language.it": "IT",
  "language.fr": "FR",
  "language.en": "EN",
  "language.sq": "SQ",

  "gallery.tag": "BEFORE &amp; AFTER",
  "gallery.heading_line1": "Results that",
  "gallery.heading_line2": "speak for themselves.",
  "gallery.subtitle": "Real transformations of our clients. Each image tells a story of renewed confidence and natural beauty.",
  "gallery.filter_all": "All",
  "gallery.filter_hair": "Dentistry",
  "gallery.filter_dental": "Dentistry",
  "gallery.filter_surgery": "Plastic Surgery",
  "gallery.before": "Before",
  "gallery.after": "After",
  "gallery.view_details": "View Details",
  "gallery.close": "Close",
  "gallery.no_results": "No results found in this category.",
  "gallery.results_count": "{{count}} Results",
  "gallery.patient": "Patient",
  "gallery.treatment": "Treatment",
  "gallery.result_after": "Result after",
  "gallery.months": "months",
  "gallery.disclaimer": "Results shown are exemplary. Individual results may vary.",

  "service_detail.how_it_works": "THE PROCESS",
  "service_detail.benefits": "YOUR BENEFITS",
  "service_detail.faq": "FAQ",
  "service_detail.process_title": "The Process",
  "service_detail.benefits_title": "Your Benefits",
  "service_detail.faq_title": "Frequently Asked Questions",
  "service_detail.cta_heading": "Ready for Your Transformation?",
  "service_detail.cta_subtitle": "Schedule your personal, no-obligation consultation now. We take time for you.",
  "pricing.back_to_pricing": "Back to Price List",
  "pricing.view_details": "Details",

  "team.tag": "OUR TEAM",
  "team.heading_line1": "Excellence needs",
  "team.heading_line2": "faces.",
  "team.subtitle": "Meet the experts who make Esteva Clinic the premier destination for premium aesthetic treatments in Europe. Each team member is a master of their craft.",
  "team.show_more": "Learn more",
  "team.show_less": "Show less",
  "team.cta_heading": "Ready for your transformation?",
  "team.cta_subtitle": "Our team looks forward to meeting you and guiding you on your personal journey to new beauty.",
  "team.cta_button": "Book a consultation now",
  "clinic.tag": "OUR CLINIC",
  "clinic.heading_line1": "Spaces designed",
  "clinic.heading_line2": "for your well-being.",
  "clinic.subtitle": "Modern clinic and state-of-the-art equipment in Tirana. From the comfort of the lounge to the hygiene of the dental lab — every detail for your well-being.",
  "clinic.label_dental": "Dental Laboratory",
  "clinic.label_consultation": "Consultation Room",
  "clinic.label_waiting": "Waiting Room",
  "clinic.label_reception": "Reception Area",
  "clinic.dental_lab": "Modern dental laboratory with state-of-the-art equipment",
  "clinic.consultation": "Comfortable consultation room for personal conversations",
  "clinic.waiting": "Spacious and welcoming waiting room",
  "clinic.reception": "Modern reception area with elegant design",

  "process.tag": "YOUR PATH TO US",
  "process.heading": "Your medical journey, stress-free",
  "process.subtitle": "We guide you through every phase, ensuring a safe, comfortable, and successful experience at Esteva Clinic.",
  "process.step1.title": "Consultation",
  "process.step1.desc": "We understand your medical needs, your clinic history, and your expectations through an initial online consultation with our specialists.",
  "process.step2.title": "Personalized Plan",
  "process.step2.desc": "We create a customized treatment plan that includes all details of the procedure, timelines, costs, and complete travel organization.",
  "process.step3.title": "Medical Review & Preparation",
  "process.step3.desc": "Our team analyzes your medical records and prepares every detail in advance — including documents, travel, and accommodation.",
  "process.step4.title": "Treatment & Care",
  "process.step4.desc": "You receive a high-quality treatment at Esteva Clinic with maximum attention and a comfortable experience.",
  "process.step5.title": "Follow-up & Support",
  "process.step5.desc": "We remain by your side even after the treatment, offering continuous support and guidance for optimal recovery.",
  "trust.heading_line1": "We transform care",
  "trust.heading_line2": "into an experience of trust.",
  "trust.subtitle": "Trust the Esteva Clinic team for high-quality medical care, personalized treatments, and comprehensive support throughout your entire healing process.",
  "trust.check1": "Specialized medical consultation",
  "trust.check2": "Advanced check-ups and diagnostics",
  "trust.check3": "General and specialized surgery",
  "trust.check4": "Personalized treatments for international patients",
  "trust.check5": "Dedicated support for medical tourism",
  "trust.check6": "Support before, during, and after treatment",

  "dental.tag": "DENTAL EXPERTISE",
  "dental.heading": "Your new smile starts here",
  "dental.subtitle": "Modern solutions for your smile: dental implants, All-on-4 / All-on-6 / All-on-8, smile design, with high-quality materials and natural results.",
  "dental.implant.title": "Premium Dental Implants",
  "dental.implant.desc": "Titanium implants, durable and natural, to restore the function and aesthetics of your smile for the long term.",
  "dental.crown.title": "Zirconia Crowns",
  "dental.crown.desc": "Aesthetic and durable zirconia crowns, designed to offer a natural and long-lasting result.",
  "dental.veneer.title": "Dental Veneers",
  "dental.veneer.desc": "Thin, natural aesthetic veneers, ideal for correcting the shape, color, and alignment of teeth.",
  "dental.allon4.title": "All-on-4",
  "dental.allon4.desc": "Innovative solution with 4 dental implants per arch, enabling fixed, stable, and natural teeth.",
  "dental.allon6.title": "All-on-6",
  "dental.allon6.desc": "Advanced technique with 6 dental implants per arch, guaranteeing maximum stability and functionality.",
  "dental.allon8.title": "All-on-8",
  "dental.allon8.desc": "Complete solution with 8 dental implants per arch, ideal for ensuring maximum support and 100% functionality.",
  "dental.pterygoid.title": "Pterygoid Implants",
  "dental.pterygoid.desc": "Advanced technique using pterygoid implants to avoid bone grafting, enabling fixed teeth even in complex cases with minimal bone.",
  "dental.zygomatic.title": "Zygomatic Implants",
  "dental.zygomatic.desc": "Advanced solution with zygomatic implants for patients with severe bone loss, avoiding bone grafting and guaranteeing immediate stability and long-lasting results.",
  "dental.maxillofacial.title": "Maxillofacial Surgery",
  "dental.maxillofacial.desc": "Specialized procedures to treat complex problems of the mouth, jaw, and face, with modern techniques and maximum safety.",
  "dental.cta": "Learn more",
  "overview.tag": "OUR SPECIALTIES",
  "overview.heading": "Three Disciplines. One Standard.",
  "overview.subtitle": "Dentistry, plastic surgery and hair transplantation — each specialty with internationally experienced specialists, state-of-the-art technology and one goal: your natural beauty.",
  "overview.dental.title": "Dentistry",
  "overview.dental.desc": "From single implants to complete oral rehabilitation. State-of-the-art 3D diagnostics, high-quality materials and a team of experienced implantologists for your new smile.",
  "overview.dental.treatments": "Implants, Zirconia Crowns, Veneers, All-on-4/6/8, Whitening, Braces, Bone Grafting, Sinus Lift, Pterygoid & Zygomatic Implants",
  "overview.surgery.title": "Plastic Surgery",
  "overview.surgery.desc": "Aesthetic procedures at the highest level. From rhinoplasty and facelifts to body contouring — individual concepts with maximum safety and natural results.",
  "overview.surgery.treatments": "Rhinoplasty, Facelift, Breast Augmentation & Reduction, Eyelid Surgery, Liposuction, Abdominoplasty, Arm & Thigh Lift, Gastric Balloon",
  "overview.hair.title": "Hair Transplant",
  "overview.hair.desc": "State-of-the-art FUE micropunch technique for a naturally dense, scar-free result. Up to 5,000 grafts in one session — with free hair analysis and personalized treatment plan.",
  "overview.hair.treatments": "FUE Hair Transplant (up to 5,000 grafts), Free Hair Analysis, Personalized Treatment Plan, Permanent Natural Result",
  "overview.cta": "All Treatments & Prices",
  "implants.hero_title": "Premium Dental Implants in Albania",
  "implants.hero_subtitle": "Rediscover the joy of smiling, chewing, and speaking with confidence thanks to our premium dental implants at Esteva Clinic.",
  "implants.hero_desc": "We offer modern, safe, and personalized implant solutions for patients seeking quality, aesthetics, and long-term stability.",
  "implants.why_title": "Why choose our dental implants?",
  "implants.why_intro": "Dental implants are a fixed and lasting solution to replace missing or severely compromised teeth. At Esteva Clinic, every case is carefully studied to offer a safe, aesthetic, and functional treatment.",
  "implants.benefit1_title": "Premium materials",
  "implants.benefit1_desc": "We use carefully selected materials to guarantee resistance, biocompatibility, and long-term reliability.",
  "implants.benefit2_title": "Personalized plan",
  "implants.benefit2_desc": "Each patient receives an individual evaluation and a treatment plan tailored to their needs.",
  "implants.benefit3_title": "Natural aesthetics",
  "implants.benefit3_desc": "The goal is to achieve fixed, beautiful, and natural teeth in harmony with the patient's smile.",
  "implants.when_title": "When are dental implants indicated?",
  "implants.when_desc": "Dental implants are indicated when one or more teeth are missing, when natural teeth can no longer be saved, or when a removable prosthesis does not offer stability and comfort.",
  "implants.when_desc2": "They can be used to replace a single tooth, multiple teeth, or an entire arch with fixed solutions such as All-on-4, All-on-6, or Toronto Bridge.",
  "implants.path_title": "Our implant journey",
  "implants.path_step1_title": "1. Evaluation",
  "implants.path_step1_desc": "Case analysis, specialist consultation, and study of the dental situation.",
  "implants.path_step2_title": "2. Treatment plan",
  "implants.path_step2_desc": "Creation of a personalized plan with timelines, materials, and clear costs.",
  "implants.path_step3_title": "3. Implant placement",
  "implants.path_step3_desc": "Procedure performed by an experienced medical team in a safe and controlled environment.",
  "implants.path_step4_title": "4. Fixed teeth",
  "implants.path_step4_desc": "Creation of the final prosthesis for a stable, functional, and aesthetic smile.",
  "implants.cta_title": "Request a personalized evaluation",
  "implants.cta_desc": "Send a dental panoramic or contact us for an initial evaluation. Our team will guide you toward the best solution for your case.",
  "implants.cta_button": "Book an appointment",

  "imprint.title": "Legal Notice",
  "imprint.responsible": "Responsible for Content",
  "imprint.address_label": "Address",
  "imprint.phone_label": "Phone",
  "imprint.email_label": "Email",
  "imprint.authorized_label": "Authorized Representatives",
  "imprint.register_label": "Commercial Register",
  "imprint.vat_label": "VAT ID",
  "imprint.disclaimer_title": "Disclaimer",
  "imprint.disclaimer_text": "The content of this website is created with the utmost care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content. Despite careful content control, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.",
  "imprint.copyright_title": "Copyright",
  "imprint.copyright_text": "The content and works created by the site operators on these pages are subject to copyright law. Reproduction, editing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.",
  "imprint.data_protection_link": "Privacy Policy",

  "booking.find_us": "FIND US",
  "booking.visit_us": "Visit us in Tirana",
  "booking.visit_subtitle": "Our clinic is located in the heart of Tirana. Book an appointment and meet us in person.",

  "agb.title": "Terms & Conditions",
  "agb.meta_desc": "General Terms and Conditions of the Esteva.ch brokerage platform. Information on scope, liability, services and applicable law.",

  "hero.discover_prices": "Discover prices",

  "services.hero_subtitle": "Three disciplines, one standard: absolute perfection. Dentistry, plastic surgery and hair transplantation in the heart of Tirana – up to 70% cheaper than in DE/AT/CH.",
  "services.page_cta_title": "Ready for your transformation?",
  "services.page_cta_subtitle": "Book your personal consultation in Tirana now. Our team of experts will create a tailored treatment concept – perfectly aligned with your wishes.",

  "testimonials.hero_subtitle": "Real transformations, real emotions. Our clients come from all over Europe to Tirana — and leave with a new sense of life.",
  "testimonials.rating": "★ 4.9 / 5.0 — based on over 240 verified reviews from our clients across Europe.",
  "testimonials.cta_title": "Become part of our success stories",
  "testimonials.cta_subtitle": "Your transformation begins with a conversation. Let us find out together how we can enhance your natural beauty.",
  "testimonials.hero_tag": "REAL EXPERIENCES",
  "testimonials.filter_all": "All",
  "testimonials.filter_dental": "Dentistry",
  "testimonials.filter_surgery": "Surgery",
  "testimonials.filter_hair": "Hair Transplant",
  "testimonials.based_on": "Based on {{count}} verified reviews",
  "testimonials.rating_breakdown": "Rating Breakdown",
  "testimonials.verified": "Verified",
  "testimonials.time_ago_months": "{{count}} months ago",
  "testimonials.time_ago_months_one": "1 month ago",
  "testimonials.time_ago_years": "{{count}} year ago",
  "testimonials.time_ago_years_plural": "{{count}} years ago",
  "testimonials.empty_title": "No reviews in this category",
  "testimonials.empty_subtitle": "Check another category or browse all reviews.",

  "about.vision_title": "A vision born by the Mediterranean",
  "about.vision_para2": "Founded by Dr. Nertila Basha, an internationally trained specialist in aesthetic medicine, Esteva Clinic unites the best of two worlds: the precision and expertise of international top-tier medicine with the warm, authentic hospitality of the Balkans. Our team of 11 experts — including specialists in hair surgery, dental cosmetics and aesthetic medicine — works hand in hand to achieve the optimal result for every client.",
  "about.meet_team_link": "Meet our team",
  "about.albania_title": "Albania — a country on the rise",
  "about.albania_subtitle": "Tirana is no longer a secret. The Albanian capital is rapidly developing into one of Southeast Europe's most dynamic economic and cultural centers — and Esteva Clinic is right in the middle of it.",
  "about.albania_card1_title": "Economic miracle of the Balkans",
  "about.albania_card1_desc": "Albania has been recording record growth for years. International investments, modern infrastructure and a young, highly motivated population are making Tirana a hotspot for innovation and progress.",
  "about.albania_card2_title": "Nature that inspires",
  "about.albania_card2_desc": "From the turquoise Adriatic in the west to the majestic Albanian Alps in the north — Albania combines Mediterranean lightness with alpine grandeur in the smallest of spaces.",
  "about.albania_card3_title": "Europe's new magnet",
  "about.albania_card3_desc": "More and more travelers, digital nomads and international companies are discovering Albania. Tirana was named by Time Magazine as one of the most exciting cities in the world.",
  "about.experience_title": "Experience Esteva Clinic yourself",
  "about.experience_subtitle": "Visit us in Tirana. Or start with a personal consultation — in person or online.",

  "booking.form_name_label": "Name",
  "booking.form_name_placeholder": "Your full name",
  "booking.form_phone_short": "Phone",
  "booking.form_treatment_label": "Desired treatment",
  "booking.form_message_optional": "Message (optional)",
  "booking.form_select_please": "Please select",
  "booking.form_message_short_placeholder": "Your message to us...",
  "booking.opening_hours_label": "Opening Hours",
  "booking.day_mofr": "Mon – Fri",
  "booking.day_saturday": "Saturday",
  "booking.day_sunday": "Sunday",
  "booking.day_closed": "Closed",
  "booking.albania_text": "Albania",

  "contact.hero_tag": "We're here for you",
  "contact.hero_title_line1": "Write to us.",
  "contact.hero_title_line2": "We reply within 24h.",
  "contact.hero_subtitle": "Free initial consultation, price inquiries or simply questions — the Esteva team looks forward to your message.",
  "contact.form_title": "Send a message",
  "contact.form_required_hint": "All fields marked with * are required.",
  "contact.firstname_label": "First name",
  "contact.lastname_label": "Last name",
  "contact.phone_optional": "Phone",
  "contact.subject_label": "Subject",
  "contact.subject_placeholder": "Please select...",
  "contact.subject_dental": "Dentistry & Implants",
  "contact.subject_surgery": "Plastic Surgery",
  "contact.subject_hair": "Hair Transplant",
  "contact.subject_general": "General Consultation",
  "contact.subject_price": "Price Inquiry",
  "contact.subject_other": "Other",
  "contact.message_label": "Your message",
  "contact.message_max": "(max. 500 characters)",
  "contact.privacy_contact": "I have read the privacy policy and agree that my data will be used to process my inquiry.",
  "contact.sending": "Sending...",
  "contact.submit": "Send message",
  "contact.success_title": "Thank you!",
  "contact.success_message": "Your message has been received. We will get back to you within 24 hours.",
  "contact.new_message": "Send a new message",
  "contact.info_title": "Contact Information",
  "contact.follow_us": "Follow us",
  "contact.book_title": "Prefer direct?",
  "contact.book_online": "Book appointment online",
  "contact.book_free": "Free initial consultation",
  "contact.maps_open": "Open in Google Maps",
  "contact.find_us_label": "FIND US",
  "contact.opening_hours": "Opening Hours",
  "contact.address_label": "Address",
  "contact.monday_friday": "Mon – Fri",
  "contact.saturday": "Saturday",
  "contact.sunday": "Sunday",
  "contact.closed": "Closed",
  "instagram.followers": "Followers",
  "instagram.posts": "Posts",
  "instagram.likes_label": "Likes",

  // ══════════════════════════════════════════
  // SEO Meta Tags – multilingual
  // ══════════════════════════════════════════
  "seo.ogLocale": "en_US",
  "seo.home.title": "Esteva Clinic – Premium Dentistry & Plastic Surgery | Dental Cosmetics & Beauty Surgery in Tirana",
  "seo.home.description": "Esteva Clinic in Tirana, Albania – Your premium clinic for dentistry and plastic surgery. Dental implants, veneers, facelift, rhinoplasty & more. International expert team. Up to 70% cheaper than Germany/Austria/Switzerland. Book your consultation now.",
  "seo.home.keywords": "Esteva Clinic, dentistry Tirana, plastic surgery Albania, dental implants, veneers, facelift, rhinoplasty, breast augmentation, dental tourism, beauty surgery abroad, aesthetic medicine Tirana",
  "seo.about.title": "About Us – Esteva Clinic | Premium Beauty Clinic in Tirana, Albania",
  "seo.about.description": "Esteva Clinic in Tirana, Albania: Our story, philosophy and international expert team. Discover why we are the premier address for premium aesthetics in the heart of the Balkans.",
  "seo.about.keywords": "Esteva Clinic Tirana, dentistry Albania, plastic surgery Tirana, aesthetic medicine Tirana, Dr. Nertila Basha, premium Balkan clinic, dental tourism Albania",
  "seo.services.title": "Services – Esteva Clinic | Dentistry, Surgery & Hair Transplant in Tirana",
  "seo.services.description": "Esteva Clinic services in Tirana: Premium dentistry with dental implants, veneers, zirconia crowns, plus plastic surgery and FUE hair transplant up to 5,000 grafts. Up to 70% cheaper than DE/AT/CH.",
  "seo.services.keywords": "Dentistry Tirana, plastic surgery Albania, hair transplant Tirana, FUE hair transplant, dental implants, facelift, rhinoplasty, Esteva Clinic services",
  "seo.pricing.title": "Price List Dental, Surgery & Hair Transplant – Esteva Clinic Tirana | Transparent Costs",
  "seo.pricing.description": "Complete price list of Esteva Clinic Tirana: Dental implants from €350, rhinoplasty from €2,200, FUE hair transplant from €1,500. All prices including hotel, taxi & 3D scan.",
  "seo.pricing.keywords": "Esteva Clinic prices, dental price list Tirana, dental implant costs, plastic surgery prices Albania, hair transplant costs, FUE hair transplant, rhinoplasty costs, breast augmentation price",
  "seo.testimonials.title": "Reviews – Esteva Clinic | Real Customer Experiences from Tirana",
  "seo.testimonials.description": "Real reviews from Esteva Clinic clients: Dentistry and plastic surgery in Tirana. Read why our clients come to us from all over Europe – up to 70% cheaper.",
  "seo.testimonials.keywords": "Esteva Clinic reviews, dentistry experiences, plastic surgery testimonials, facelift reviews, dental implant experiences, customer testimonials aesthetic medicine",
  "seo.booking.title": "Book Appointment – Esteva Clinic | Schedule a Consultation in Tirana",
  "seo.booking.description": "Book your personal consultation at Esteva Clinic in Tirana. Dentistry, plastic surgery & aesthetic medicine. Free initial consultation – up to 70% cheaper than DE/AT/CH.",
  "seo.booking.keywords": "Consultation Tirana, Esteva Clinic booking, dentistry appointment, plastic surgery consultation, facelift consultation, dental implant consultation, beauty clinic appointment",
  "seo.gallery.title": "Gallery – Esteva Clinic | Before & After Results from Tirana",
  "seo.gallery.description": "Impressive before & after results from Esteva Clinic in Tirana: Dental implants, veneers, facelift, rhinoplasty & more. Real results from real clients across Europe.",
  "seo.gallery.keywords": "Before after gallery, dentistry results, veneers results, facelift transformations, rhinoplasty results, Esteva Clinic, aesthetic medicine images",
  "seo.team.title": "Team – Esteva Clinic | International Expert Team in Tirana",
  "seo.team.description": "Meet the international expert team at Esteva Clinic in Tirana. Specialists in dentistry, plastic surgery & aesthetic medicine. Multilingual, experienced, passionate.",
  "seo.team.keywords": "Esteva Clinic team, Esteva Clinic Tirana, plastic surgeons Tirana, dentistry experts Albania, dental specialists, aesthetic surgery doctors",
  "seo.contact.title": "Contact – Esteva Clinic | Request a Consultation in Tirana",
  "seo.contact.description": "Get in touch with Esteva Clinic in Tirana. Free consultation for dentistry, plastic surgery & hair transplant. Send your inquiry now!",
  "seo.contact.keywords": "Contact Esteva Clinic, consultation Tirana, dentistry inquiry, surgery consultation Albania",
  "seo.imprint.title": "Legal Notice – Esteva Clinic | Rruga Bylis, Tiranë 1001, Albania",
  "seo.imprint.description": "Legal notice of Esteva Clinic Tirana. Legal information, responsible parties, address and contact details of Esteva Clinic in Albania.",
  "seo.imprint.keywords": "Legal notice, Esteva Clinic, Tirana, Albania, legal information, contact Esteva Clinic",
  "seo.dental_implants.title": "Premium Dental Implants – Esteva Clinic | Dentistry Tirana",
  "seo.dental_implants.description": "Premium dental implants in Tirana, Albania. Modern, safe and personalized implant solutions. Up to 70% cheaper than DE/AT/CH. Request your free consultation now.",
  "seo.dental_implants.keywords": "Dental implants Tirana, dental implants Albania, implant costs, All-on-4 Tirana, All-on-6 Albania, Esteva Clinic implants",
  "seo.agb.keywords": "Terms, Esteva Clinic, conditions, Esteva.ch",

  // ══════════════════════════════════════════
  // Privacy Policy
  // ══════════════════════════════════════════
  "privacy.title": "Privacy Policy",
  "privacy.subtitle": "Esteva.ch — Brokerage Platform for Medical and Aesthetic Services",
  "privacy.date": "Last updated: June 11, 2026",
  "privacy.last_updated": "Last updated",
  "privacy.s1_title": "1. Data Controller",
  "privacy.s1_text": "The controller responsible for data processing on this platform is:\n\nAI Vision GmbH\nUnterdorf 8, 8222 Beringen, Switzerland\nEmail: info@esteva.ch\n(Intermediary / Platform Operator)\n\nJoint controller for the processing of your medical inquiries:\nNertila Basha\nEuromed Dental Maxillofacial & Aesthetic Center\nRruga Bylis, Tiranë 1001, Albania\n\nThis Privacy Policy applies in accordance with the Swiss Federal Act on Data Protection (FADP/revFADP) and, where applicable, the EU General Data Protection Regulation (GDPR).",
  "privacy.s2_title": "2. What Data We Collect",
  "privacy.s2_text": "We collect the following categories of personal data:\n\n• Contact data: Name, email address, telephone number\n• Treatment requests and inquiries (voluntarily provided by you)\n• Technical data: IP address, browser type, visit time, pages accessed\n• Communication data: Messages via contact forms or WhatsApp\n\nWe do not collect special categories of personal data (e.g., health data) without your explicit consent.",
  "privacy.s3_title": "3. Purpose of Data Processing",
  "privacy.s3_text": "Your data is used exclusively for the following purposes:\n\n• Referral to the desired service provider (clinic)\n• Responding to inquiries and scheduling appointments\n• Improving the platform and technical administration\n• Compliance with legal obligations",
  "privacy.s4_title": "4. Data Sharing",
  "privacy.s4_text": "4.1 Your contact data and treatment request will be forwarded to the service provider you selected (clinic in Albania) so that they can process your inquiry.\n\n4.2 We do not share your data with third parties for commercial purposes.\n\n4.3 Data transfer abroad (Albania) is based on your consent. Albania is not considered a country with a level of data protection equivalent to that of Switzerland; the transfer is based on your explicit consent in accordance with Art. 17 revFADP.",
  "privacy.s5_title": "5. Cookies and Tracking",
  "privacy.s5_text": "5.1 Our platform uses technically necessary cookies for the operation of the website.\n\n5.2 We may use analytics tools (e.g., Google Analytics). You can object to the use of analytics cookies at any time.\n\n5.3 You can disable cookies in your browser settings; this may limit the functionality of the platform.",
  "privacy.s6_title": "6. Retention Period",
  "privacy.s6_text": "We store your personal data only for as long as necessary for the stated purposes. Inquiry data will be deleted after a maximum of 2 years.",
  "privacy.s7_title": "7. Your Rights",
  "privacy.s7_text": "You have the following rights regarding your personal data:\n\n• Right of access: Information about stored data\n• Right to rectification: Correction of inaccurate data\n• Right to erasure: Deletion of your data unless legal obligations prevent it\n• Right to object: Objection to data processing\n• Right to data portability: Provision of your data in a commonly used format\n\nTo exercise your rights: info@esteva.ch\n\nComplaints may be submitted to the Swiss Federal Data Protection and Information Commissioner (FDPIC): www.edoeb.admin.ch",
  "privacy.s8_title": "8. Data Security",
  "privacy.s8_text": "We take appropriate technical and organizational measures to protect your personal data (e.g., SSL/TLS encryption).",
  "privacy.s9_title": "9. Third-Party Services",
  "privacy.s9_text": "The platform may use the following third-party services:\n\n• Google Maps — Privacy Policy: policies.google.com/privacy\n• WhatsApp Business — Privacy Policy: www.whatsapp.com/legal/privacy-policy",
  "privacy.s10_title": "10. Changes to This Privacy Policy",
  "privacy.s10_text": "We reserve the right to amend this Privacy Policy at any time. The current version is available at www.Esteva.ch.\n\nAI Vision GmbH | Unterdorf 8, 8222 Beringen | info@esteva.ch | www.Esteva.ch",

  // SEO
  "seo.privacy.title": "Privacy Policy – Esteva.ch | AI Vision GmbH, Beringen, Switzerland",
  "seo.privacy.description": "Privacy Policy of the Esteva.ch brokerage platform. Information on the collection, processing, and sharing of personal data in accordance with Swiss FADP/revFADP and EU GDPR. Data controller: AI Vision GmbH, Beringen, Switzerland.",
  "seo.privacy.keywords": "Privacy Policy, Esteva.ch, AI Vision GmbH, data protection, FADP, revFADP, GDPR, personal data, Beringen, Switzerland",

  // ══════════════════════════════════════════
  // Admin-Dashboard
  // ══════════════════════════════════════════
  "admin.logo": "ESTEVA ADMIN",
  "admin.to_website": "Visit Website",
  "admin.logout": "Logout",
  "admin.sidebar_expand": "Expand sidebar",
  "admin.sidebar_collapse": "Collapse sidebar",
  "admin.nav_dashboard": "Overview",
  "admin.nav_pages": "Pages & Content",
  "admin.nav_treatments": "Treatments & Prices",
  "admin.nav_team": "Team",
  "admin.nav_reviews": "Reviews",
  "admin.nav_bookings": "Bookings & Appointments",
  "admin.nav_media": "Images & Media",
  "admin.nav_translations": "Languages & Translations",
  "admin.nav_footer": "Footer & Contact",
  "admin.nav_seo": "SEO",
  "admin.nav_settings": "Settings",
  "admin.breadcrumb_admin": "Admin",
  "admin.header_settings": "Settings",

  "admin.dashboard_title": "Dashboard",
  "admin.dashboard_welcome": "Welcome back! Here's your overview.",
  "admin.stat_bookings": "Bookings",
  "admin.stat_bookings_sub": "{{count}} new",
  "admin.stat_confirmed": "Confirmed",
  "admin.stat_confirmed_sub": "active",
  "admin.stat_today": "Today",
  "admin.stat_today_sub": "Appointments",
  "admin.stat_treatments": "Treatments",
  "admin.stat_treatments_sub": "Price lists",
  "admin.stat_team": "Team",
  "admin.stat_team_sub": "Members",
  "admin.stat_reviews": "Reviews",
  "admin.stat_reviews_sub": "Testimonials",

  "admin.upcoming_title": "Upcoming Appointments",
  "admin.today_label": "Today",
  "admin.upcoming_label": "Upcoming",
  "admin.no_future_bookings": "No further appointments scheduled.",
  "admin.view_all": "View all",

  "admin.status_new": "New",
  "admin.status_confirmed": "Confirmed",
  "admin.status_done": "Done",

  "admin.activity_title": "Recent Activity",
  "admin.activity_empty": "No activity yet.",
  "admin.activity_just_now": "just now",
  "admin.activity_min_ago": "{{count}} min ago",
  "admin.activity_hour_ago": "{{count}} hr ago",
  "admin.activity_day_ago": "{{count}} day ago",
  "admin.activity_days_ago": "{{count}} days ago",

  "admin.quick_title": "Quick Access",
  "admin.quick_home": "Edit Homepage",
  "admin.quick_bookings": "Manage Bookings",
  "admin.quick_pricing": "Edit Price List",
  "admin.quick_team": "Manage Team",

  "admin.service_hair": "Hair Transplant",
  "admin.service_dental": "Dental Cosmetics",
  "admin.service_botox": "Botox & Fillers",
  "admin.service_combined": "Combined Treatment",
  "admin.service_consultation": "Consultation",

  "team.nertila-basha.title": "CEO, Dentist, Implantologist & Prosthodontist",
  "team.nertila-basha.specialty": "Dental Implants & Aesthetic Prosthodontics",
  "team.nertila-basha.bio": "Dr. Nertila Basha is CEO, dentist, implantologist and prosthodontist with extensive experience in dentistry. She is known for clinical precision and attention to detail, offering modern, individually tailored treatments for every patient. Her goal is to guarantee functional and aesthetic results at the highest level, always keeping the patient's health and wellbeing at the center.",
  "team.nertila-basha.certifications": ["Specialist in Dentistry", "Implantology & Prosthodontics", "University of Tirana"],

  "team.denisa-zhegu.title": "Aesthetic Medicine Physician",
  "team.denisa-zhegu.specialty": "Dermo-Aesthetic Treatments",
  "team.denisa-zhegu.bio": "Dr. Denisa Zhegu is an aesthetic medicine physician with international training, specializing in advanced dermo-aesthetic treatments. She is known for using modern and safe techniques, offering natural and individually adapted results for every patient. Thanks to her experience and continuous education, she is a key figure in aesthetic medicine in Tirana.",
  "team.denisa-zhegu.certifications": ["Specialist in Aesthetic Medicine", "Dermo-Aesthetic Certification", "International Academy"],

  "team.nuri-qyra.title": "Anesthesiologist & Intensive Care Specialist",
  "team.nuri-qyra.specialty": "Anesthesia & Patient Safety",
  "team.nuri-qyra.bio": "Specialist with over 40 years of experience in anesthesia and intensive care, dedicated to safety, monitoring and maximum patient comfort during every medical and surgical procedure. His calm and expertise give confidence to both patients and the team alike.",
  "team.nuri-qyra.certifications": ["Specialist in Anesthesia", "Intensive Care Medicine", "University of Tirana"],

  "team.nurie-paloka.title": "Head Operating Room Nurse",
  "team.nurie-paloka.specialty": "Surgical Assistance & OR Management",
  "team.nurie-paloka.bio": "With 37 years of experience in surgical assistance and OR management, she is dedicated to the highest level of professionalism, organization and patient care during every medical procedure. She coordinates the entire surgical process with precision and heart.",
  "team.nurie-paloka.certifications": ["Head OR Nurse", "Surgical Assistance", "Clinic Management"],

  "team.ermir-mehillej.title": "Implant Surgeon",
  "team.ermir-mehillej.specialty": "Dental Implantology & Surgery",
  "team.ermir-mehillej.bio": "Dr. Ermir Mehillej is a dentist and surgical implantologist with 8 years of experience. He specializes in traditional implantology, pterygoid and zygomatic implants, handling even the most complex cases with precision and competence. Thanks to his extensive experience he offers safe, functional and aesthetically advanced solutions for every patient.",
  "team.ermir-mehillej.certifications": ["Specialist in Dentistry", "Implant Surgery", "Zygomatic & Pterygoid Implants"],

  "team.roel-ferataj.title": "Implant Surgeon",
  "team.roel-ferataj.specialty": "Dental Implantology & Surgery",
  "team.roel-ferataj.bio": "Dr. Roel Ferataj is a dentist and surgical implantologist with 4 years of experience. He specializes in traditional implantology, pterygoid and zygomatic implants and is known for precision and care in every treatment, even the most complex cases. With a professional approach and great attention to patient needs he offers modern, safe and aesthetically harmonious solutions.",
  "team.roel-ferataj.certifications": ["Specialist in Dentistry", "Implant Surgery", "Advanced Implantology"],

  "team.ana-bardhi.title": "Dentist – Prosthodontics & Endodontics",
  "team.ana-bardhi.specialty": "Prosthodontics, Endodontics & Aesthetic Rehabilitation",
  "team.ana-bardhi.bio": "Dr. Ana Bardhi is a specialist in dental prosthodontics and endodontics with 6 years of clinical experience. She focuses on aesthetic and functional smile rehabilitation, offering personalized treatments and modern solutions for every patient. Thanks to her professionalism and attention to detail she guarantees high-quality treatments in a welcoming and safe environment.",
  "team.ana-bardhi.certifications": ["Prosthodontics Specialist", "Endodontics Specialist", "Aesthetic Dentistry"],

  "team.rigers-xaka.title": "Dental Assistant",
  "team.rigers-xaka.specialty": "Clinical Assistance & Patient Care",
  "team.rigers-xaka.bio": "Rigers Xaka is a dental assistant with 2 years of experience in the dental field. He supports the medical team during clinical procedures and helps ensure an organized, safe and welcoming environment for patients. Thanks to his professionalism and attention to detail he provides efficient assistance at every stage of treatment.",
  "team.rigers-xaka.certifications": ["Dental Assistant", "Clinical Support", "Patient Management"],

  "team.luciana-basha.title": "Endodontist",
  "team.luciana-basha.specialty": "Root Canal Treatment & Preservation of Natural Teeth",
  "team.luciana-basha.bio": "Endodontics physician with 3 years of experience in root canal treatment and the preservation of natural teeth. She is dedicated to precise, minimally invasive and pain-free treatments, uses modern techniques and always puts patient comfort and health first.",
  "team.luciana-basha.certifications": ["Endodontics Specialist", "Root Canal Specialist", "University of Tirana"],

  "team.gezim-kabashi.title": "Driver & Patient Care",
  "team.gezim-kabashi.specialty": "Organizational Support & Transportation",
  "team.gezim-kabashi.bio": "Specializing in comprehensive patient care throughout their entire stay in Albania. He provides organizational support, professional communication and a comfortable experience from the moment of arrival until the end of treatment.",
  "team.gezim-kabashi.certifications": ["Patient Care", "Driver", "Organizational Management"],

  "team.griselda.title": "Clinic Coordinator",
  "team.griselda.specialty": "Clinic Management & Patient Coordination",
  "team.griselda.bio": "Griselda is the clinic coordinator with over 10 years of experience in managing and coordinating clinics and hospital structures. Thanks to her organizational skills and attention to patients she guarantees an efficient, professional and well-organized treatment process. She is the point of contact for patient care and support throughout all phases of treatment.",
  "team.griselda.certifications": ["Clinic Management", "Patient Coordination", "Healthcare Administration"],
  "home.seo_service_areas_label": "Service areas & treatments",
  "home.instagram_error": "Instagram posts could not be loaded.",
  "home.instagram_retry": "Try again",
  "home.instagram_empty_title": "No posts yet.",
  "home.instagram_empty_subtitle": "Follow us on Instagram for exclusive insights.",
  "home.booking_reception_alt": "Esteva Clinic reception",
  "home.newsletter_exists": "This email is already subscribed.",
  "home.newsletter_error": "An error occurred. Please try again.",
  "home.developed_by": "Developed by",
  "svc.pricing_hero_tag": "Price List",
  "svc.savings_tag": "Price Comparison",
  "svc.savings_title": "This is how much you save in comparison",
  "svc.savings_subtitle": "Same quality, state-of-the-art technology — at a fraction of the cost in Germany, Austria or Switzerland.",
  "svc.savings_col_treatment": "Treatment",
  "svc.savings_col_savings": "Savings",
  "svc.packages_tag": "Treatment Packages",
  "svc.faq_heading": "Frequently Asked Questions",
  "svc.pricing_cta_subtitle": "Still unsure which treatment is right for you? In a personal consultation we will find the ideal solution together.",
  "svc.pricing_faq1_q": "What is included in the price packages?",
  "svc.pricing_faq1_a": "Each package covers the treatments listed as well as the stated aftercare. In a personal consultation we clarify all the details and tailor the package exactly to your individual needs.",
  "svc.pricing_faq2_q": "Are there any hidden costs?",
  "svc.pricing_faq2_a": "No. At Esteva Clinic, transparency comes first. The price agreed during the consultation is binding. There are no hidden additional costs.",
  "svc.pricing_faq3_q": "Can I combine treatments?",
  "svc.pricing_faq3_a": "Of course. Many of our clients want a combination of different treatments. We are happy to discuss individual combinations during the consultation.",
  "svc.pricing_faq4_q": "Which payment methods do you accept?",
  "svc.pricing_faq4_a": "We accept credit cards (Visa, Mastercard, American Express), bank transfer as well as installment payments through our partner. You will receive details in a personal conversation.",
  "svc.pricing_faq5_q": "How long does the aftercare last?",
  "svc.pricing_faq5_a": "Aftercare varies depending on the treatment. All aftercare appointments take place at our clinic in Tirana. A detailed plan is drawn up during your consultation.",
  "svc.price_from": "from ",
  "svc.price_fixed": "Fixed price",
  "svc.view_details_link": "View details",
  "svc.dental_subtitle": "Transparent fixed prices for all dental treatments — including state-of-the-art technology and experienced specialists.",
  "svc.dental_cat_implants_label": "Implants",
  "svc.dental_cat_crowns_label": "Crowns & Bridges",
  "svc.dental_cat_aesthetics_label": "Aesthetics & Braces",
  "svc.dental_cat_bone_label": "Bone Grafting",
  "svc.dental_cat_prosthetics_label": "Prosthetics",
  "svc.dental_cat_implants_desc": "Modern implants made of high-quality materials for a firm bite that lasts a lifetime.",
  "svc.dental_cat_crowns_desc": "Highly aesthetic crowns made of zirconia or ceramic — perfectly matched to your tooth color.",
  "svc.dental_cat_aesthetics_desc": "Your most beautiful smile: from professional cleaning to invisible braces.",
  "svc.dental_cat_bone_desc": "Necessary preliminary treatments for secure implant anchoring in the jaw.",
  "svc.dental_cat_prosthetics_desc": "Flexible and comfortable prosthetic care for a better quality of life.",
  "svc.surgery_subtitle": "Plastic and aesthetic surgery at the highest level — including all pre- and aftercare in Tirana.",
  "svc.surgery_cat_face_label": "Face & Lifting",
  "svc.surgery_cat_breast_label": "Breast Surgery",
  "svc.surgery_cat_body_label": "Body Contouring",
  "svc.surgery_cat_special_label": "Special Procedures",
  "svc.surgery_cat_face_desc": "The finest aesthetic surgery for a harmonious, natural facial profile.",
  "svc.surgery_cat_breast_desc": "Naturally beautiful proportions through state-of-the-art surgical techniques and Mentor implants.",
  "svc.surgery_cat_body_desc": "Defined body contours: from liposuction to comprehensive tightening.",
  "svc.surgery_cat_special_desc": "Innovative special procedures for your individual wishes.",
  "svc.hair_subtitle": "State-of-the-art FUE technique with sapphire blades — naturally dense hair, scar-free and lifelong.",
  "svc.hair_bestseller": "Bestseller",
  "svc.hair_treatment_label": "Treatment",
  "svc.hair_total_price": "Total price",
  "svc.hair_all_inclusive": "All-inclusive package",
  "svc.hair_graft_overview": "Graft packages at a glance",
  "svc.hair_popular": "Popular",
  "svc.hair_ideal_for": "Ideal for:",
  "svc.hair_included_title": "Included in the all-inclusive package",
  "svc.hair_none_available": "No hair transplant treatments available.",
  "svc.hair_tech_method_label": "Method",
  "svc.hair_tech_method_value": "FUE (Follicular Unit Extraction) — scar-free",
  "svc.hair_tech_grafts_label": "Grafts",
  "svc.hair_tech_grafts_value": "Up to 5,000 grafts in a single session",
  "svc.hair_tech_duration_label": "Duration",
  "svc.hair_tech_duration_value": "6–8 hours (one appointment)",
  "svc.hair_tech_anesthesia_label": "Anesthesia",
  "svc.hair_tech_anesthesia_value": "Local anesthesia with sedation",
  "svc.hair_tech_guarantee_label": "Guarantee",
  "svc.hair_tech_guarantee_value": "Lifelong dense result",
  "svc.hair_tech_return_label": "Return journey",
  "svc.hair_tech_return_value": "Possible from day 3 after surgery",
  "svc.hair_incl_1": "Personal consultation &amp; hair analysis",
  "svc.hair_incl_2": "Blood test &amp; health check",
  "svc.hair_incl_3": "FUE treatment with sapphire blades",
  "svc.hair_incl_4": "PRP (platelet-rich plasma) to promote healing",
  "svc.hair_incl_5": "Special aftercare shampoo set",
  "svc.hair_incl_6": "All follow-up check-ups in Tirana",
  "svc.hair_graft1_count": "Up to 2,000",
  "svc.hair_graft1_desc": "Smaller gaps &amp; receding hairline",
  "svc.hair_graft1_ideal": "Mild hair loss",
  "svc.hair_graft2_desc": "Front area &amp; crown",
  "svc.hair_graft2_ideal": "Moderate hair loss",
  "svc.hair_graft3_desc": "Complete restoration",
  "svc.hair_graft3_ideal": "Advanced hair loss",
  "svc.detail_not_found": "Treatment not found",
  "svc.detail_back_home": "Back to homepage",
  "info.map_title": "Esteva Clinic location map",
  "info.hero_image_alt": "Esteva Clinic appointment booking",
  "legal.location_title": "Location",
  "legal.notfound_seo_title": "Page not found – Esteva Clinic",
  "legal.notfound_seo_description": "The requested page could not be found. Return to the Esteva Clinic homepage.",
  "legal.notfound_title": "This page could not be found",
  "legal.notfound_subtitle": "The page you are looking for does not exist.",
  "adm1.service_surgery": "Surgery",
  "adm1.saved": "Saved!",
  "adm1.save_error": "Error while saving",
  "adm1.save_error_dot": "Error while saving.",
  "adm1.save": "Save",
  "adm1.cancel": "Cancel",
  "adm1.delete": "Delete",
  "adm1.refresh": "Refresh",
  "adm1.retry": "Try again",
  "adm1.filter_all": "All",
  "adm1.filter_visible": "Visible",
  "adm1.filter_hidden": "Hidden",
  "adm1.action_edit": "Edit",
  "adm1.action_delete": "Delete",
  "adm1.action_hide": "Hide",
  "adm1.action_show": "Show",
  "adm1.delete_irreversible": "This action cannot be undone.",
  "adm1.label_name": "Name",
  "adm1.label_email": "Email",
  "adm1.label_phone": "Phone",
  "adm1.label_package": "Package",
  "adm1.label_treatment": "Treatment",
  "adm1.label_status": "Status:",
  "adm1.label_location": "Location",
  "adm1.label_date": "Date",
  "adm1.label_rating": "Rating",
  "adm1.label_text": "Text",
  "adm1.label_visible": "Visible",
  "adm1.label_verified": "Verified",
  "adm1.bookings_title": "Bookings & Appointments",
  "adm1.bookings_summary": "{{total}} bookings · {{new}} new · {{confirmed}} confirmed · {{done}} done",
  "adm1.bookings_load_error": "Error loading bookings.",
  "adm1.bookings_status_error": "Status could not be updated.",
  "adm1.bookings_saved_notified": "Saved! The customer will be notified.",
  "adm1.bookings_loading": "Loading bookings...",
  "adm1.bookings_empty_title": "No bookings found.",
  "adm1.bookings_empty_desc": "New bookings appear here as soon as patients request an appointment through the website form.",
  "adm1.reviews_title": "Reviews",
  "adm1.reviews_summary": "{{total}} reviews · {{visible}} visible",
  "adm1.reviews_new": "New review",
  "adm1.reviews_edit": "Edit review",
  "adm1.reviews_empty_title": "No reviews yet.",
  "adm1.reviews_empty_desc": "Click \"New review\" to add the first customer testimonial.",
  "adm1.reviews_delete_confirm": "Delete review?",
  "adm1.team_title": "Team",
  "adm1.team_count": "{{count}} team members",
  "adm1.team_new": "New member",
  "adm1.team_edit": "Edit member",
  "adm1.team_delete_confirm": "Delete member?",
  "adm1.label_title_role": "Title / Role",
  "adm1.ph_title_role": "e.g. CEO, dentist",
  "adm1.label_specialty": "Specialty",
  "adm1.ph_specialty": "e.g. dental implants",
  "adm1.label_bio": "Bio",
  "adm1.label_certifications": "Certifications (comma-separated)",
  "adm1.ph_certifications": "e.g. dental specialist, implantology",
  "adm1.label_languages": "Languages (comma-separated, e.g. DE, EN, IT)",
  "adm1.label_photo": "Photo",
  "adm1.label_order": "Order (number)",
  "adm1.treatments_title": "Treatments & Prices",
  "adm1.treatments_summary": "{{count}} treatments · prices in €",
  "adm1.treatments_import": "Import default treatments",
  "adm1.treatments_new": "New treatment",
  "adm1.treatments_edit": "Edit treatment",
  "adm1.treatments_empty": "No treatments in this category.",
  "adm1.treatments_delete_confirm": "Delete treatment?",
  "adm1.importing": "Importing…",
  "adm1.import_error": "Import error",
  "adm1.col_treatment": "Treatment",
  "adm1.col_category": "Category",
  "adm1.col_price_al": "Price AL",
  "adm1.col_price_de": "Price DE",
  "adm1.col_price_at": "Price AT",
  "adm1.col_price_ch": "Price CH",
  "adm1.col_savings": "Savings",
  "adm1.ph_treatment_name": "Treatment name",
  "adm1.label_description": "Description",
  "adm1.ph_description": "Description...",
  "adm1.label_price_al": "Price Albania (€)",
  "adm1.label_price_de": "Price DE (€)",
  "adm1.label_price_at": "Price AT (€)",
  "adm1.label_price_ch": "Price CH (€)",
  "adm1.ph_price_range": "e.g. 1,500 – 2,000",
  "adm1.label_savings_percent": "Savings (%)",
  "adm1.settings_title": "Settings",
  "adm1.settings_subtitle": "Manage global website settings.",
  "adm1.settings_general": "General",
  "adm1.settings_colors": "Colors",
  "adm1.settings_change_password": "Change password",
  "adm1.settings_saved_live": "Saved! Changes are live immediately.",
  "adm1.label_website_name": "Website name",
  "adm1.label_logo_url": "Logo URL",
  "adm1.label_favicon_url": "Favicon URL",
  "adm1.label_primary_color": "Primary color",
  "adm1.label_accent_color": "Accent color",
  "adm1.label_secondary_color": "Secondary color",
  "adm1.ph_new_password": "New password...",
  "adm1.pw_too_short": "Password must be at least 6 characters long.",
  "adm1.pw_changed": "Password changed successfully!",
  "adm1.footer_title": "Footer & Contact",
  "adm1.footer_subtitle": "Contact details and footer settings of the website — exactly as shown on the page.",
  "adm1.footer_contact_data": "Contact details",
  "adm1.footer_contact_data_desc": "Phone, email, address, opening hours — as in the footer and on the contact page",
  "adm1.footer_social_desc": "Instagram & TikTok — exactly as linked in the footer and on the contact page",
  "adm1.footer_tiktok_note": "Only a placeholder (#) is currently linked on the website.",
  "adm1.footer_whatsapp_floating": "WhatsApp (Floating Button)",
  "adm1.label_whatsapp_number": "Number (without +, e.g. 41765593993)",
  "adm1.label_whatsapp_message": "Predefined message",
  "adm1.footer_texts": "Footer texts",
  "adm1.footer_texts_desc": "Tagline and copyright — as in the website footer",
  "adm1.label_tagline": "Tagline (below the logo)",
  "adm1.label_copyright": "Copyright line",
  "adm1.label_address": "Address",
  "adm1.label_city_zip": "City / ZIP",
  "adm1.label_country": "Country",
  "adm1.label_opening_hours": "Opening hours",
  "adm1.login_title": "Admin Login",
  "adm1.login_subtitle": "Esteva Clinic administration",
  "adm1.login_failed": "Login failed. Email or password incorrect.",
  "adm1.label_password": "Password",
  "adm1.ph_enter_password": "Enter password",
  "adm1.pw_hide": "Hide password",
  "adm1.pw_show": "Show password",
  "adm1.login_loading": "Signing in…",
  "adm1.login_submit": "Sign in",
  "adm2.saved": "Saved!",
  "adm2.save_error": "Error while saving.",
  "adm2.save": "Save",
  "adm2.cancel": "Cancel",
  "adm2.delete": "Delete",
  "adm2.edit": "Edit",
  "adm2.upload": "Upload",
  "adm2.reset": "Reset",
  "adm2.reset_all": "Reset all",
  "adm2.reset_lang": "Reset {{lang}}",
  "adm2.save_changes": "Save changes",
  "adm2.saving": "Saving...",
  "adm2.saved_short": "Saved",
  "adm2.saved_live": "Saved! Changes are live.",
  "adm2.remove": "Remove",
  "adm2.changed": "Changed",
  "adm2.optional": "optional",
  "adm2.preview": "Preview",
  "adm2.uploaded": "Uploaded",
  "adm2.uploading": "Uploading…",
  "adm2.uploading_progress": "Uploading...",
  "adm2.upload_failed": "Upload failed.",
  "adm2.upload_failed_retry": "Upload failed. Please try again.",
  "adm2.file_too_large": "File too large (max. 5 MB).",
  "adm2.file_too_large_compress": "File too large (max. 5 MB). Please compress it.",
  "adm2.file_too_large_max": "The file is too large. Maximum size: 5 MB.",
  "adm2.max_5mb_jpg_png": "Max. 5 MB, JPG or PNG",
  "adm2.only_jpg_png_webp": "Please upload only JPG, PNG or WebP files.",
  "adm2.only_image_files": "Please select only image files (JPG, PNG, WebP).",
  "adm2.file_read_error": "Error reading the file. Please try again.",
  "adm2.file_read_error_smaller": "Error reading the file. Try a smaller file.",
  "adm2.no_image": "No image",
  "adm2.no_image_uploaded": "No image uploaded yet",
  "adm2.image_required": "Image required",
  "adm2.edit_image": "Edit image",
  "adm2.upload_image": "Upload image",
  "adm2.remove_image": "Remove image",
  "adm2.image_url": "Image URL",
  "adm2.image_url_optional": "Image URL (optional)",
  "adm2.enter_image_url": "Or enter image URL directly...",
  "adm2.image_upload_hint": "Upload an image from your computer or paste a URL. Uploaded images are stored locally.",
  "adm2.or_url": "or URL...",
  "adm2.enter_url": "or enter URL...",
  "adm2.location": "Location",
  "adm2.description": "Description",
  "adm2.category": "Category",
  "adm2.filter_all": "All",
  "adm2.media_title": "Images & Media",
  "adm2.media_uploaded_count": "{{uploaded}} / {{total}} images uploaded",
  "adm2.manage_images": "Manage images",
  "adm2.images": "Images",
  "adm2.images_count": "{{uploaded}} / {{total}} images",
  "adm2.customized": "Customized",
  "adm2.no_images_category": "No images in this category.",
  "adm2.reset_all_images": "Reset all images",
  "adm2.gallery_comparisons": "Gallery comparisons",
  "adm2.gallery_before_after": "Gallery (Before/After)",
  "adm2.page_images": "Page images",
  "adm2.to_website": "To website",
  "adm2.gallery_intro": "Manage before/after comparison images for the gallery page. Each entry consists of a before and an after image.",
  "adm2.new_comparison": "New comparison",
  "adm2.no_gallery_images_category": "No gallery images in this category.",
  "adm2.before": "Before",
  "adm2.after": "After",
  "adm2.before_image": "Before image",
  "adm2.after_image": "After image",
  "adm2.no_label": "No label",
  "adm2.months_count": "{{count}} months",
  "adm2.new_before_after": "New before/after comparison",
  "adm2.edit_comparison": "Edit comparison",
  "adm2.add_comparison": "Add comparison",
  "adm2.patient_label": "Patient label",
  "adm2.patient_label_ph": "e.g. Patient 29K",
  "adm2.treatment_label": "Treatment label",
  "adm2.treatment_label_ph": "e.g. Dental Cosmetics",
  "adm2.result_after_months": "Result after (months)",
  "adm2.result_desc_ph": "Short description of the result...",
  "adm2.cat_hero": "Hero & Backgrounds",
  "adm2.cat_services": "Services",
  "adm2.cat_about": "About us / Clinic",
  "adm2.cat_pricing": "Prices / Packages",
  "adm2.cat_gallery": "Gallery (Before/After)",
  "adm2.cat_team": "Team",
  "adm2.cat_instagram": "Instagram / Social",
  "adm2.gcat_dental": "Dental Cosmetics",
  "adm2.gcat_surgery": "Surgery",
  "adm2.gcat_hair": "Hair Transplant",
  "adm2.gcat_aesthetic": "Aesthetics",
  "adm2.img_home_hero_bg": "Home — Hero background",
  "adm2.img_home_cta_bg": "Home — CTA background",
  "adm2.img_home_process": "Home — Process background",
  "adm2.img_home_trust": "Home — Trust background",
  "adm2.img_about_hero": "About us — Hero (Tirana)",
  "adm2.img_services_hero": "Services — Hero",
  "adm2.img_pricing_hero": "Prices — Hero",
  "adm2.img_gallery_hero": "Gallery — Hero",
  "adm2.img_booking_hero": "Booking — Hero",
  "adm2.img_hair": "Hair transplant — Image",
  "adm2.img_dental": "Dental cosmetics — Image",
  "adm2.img_botox": "Botox & Filler — Image",
  "adm2.confirm_delete": "Really delete?",
  "adm2.no_subscribers": "No subscribers available.",
  "adm2.csv_email": "Email",
  "adm2.csv_language": "Language",
  "adm2.csv_status": "Status",
  "adm2.csv_date": "Date",
  "adm2.col_email": "Email",
  "adm2.col_language": "Language",
  "adm2.col_status": "Status",
  "adm2.col_date": "Date",
  "adm2.col_actions": "Actions",
  "adm2.pages_content_title": "Pages & Content",
  "adm2.pages_content_subtitle": "Edit the content of every page of the website.",
  "adm2.language_label": "Language:",
  "adm2.editable_fields_count": "{{count}} editable fields",
  "adm2.editable_fields_count2": "{{count}} editable fields",
  "adm2.no_fields_configured": "No fields configured for this page.",
  "adm2.pc_page_home": "Home",
  "adm2.pc_page_services": "Services",
  "adm2.pc_page_about": "About us",
  "adm2.pc_page_pricing": "Prices",
  "adm2.pc_page_gallery": "Gallery",
  "adm2.pc_page_team": "Team",
  "adm2.pc_page_booking": "Booking",
  "adm2.pc_page_contact": "Contact",
  "adm2.pc_hero_headline": "Hero headline",
  "adm2.pc_hero_subline": "Hero subline",
  "adm2.pc_hero_button": "Hero button",
  "adm2.pc_about_heading": "About us heading",
  "adm2.pc_about_text": "About us text",
  "adm2.pc_services_heading": "Services heading",
  "adm2.pc_pricing_heading": "Prices heading",
  "adm2.pc_testimonials_heading": "Testimonials heading",
  "adm2.pc_hair_title": "Hair transplant title",
  "adm2.pc_hair_desc": "Hair transplant description",
  "adm2.pc_hair_heading": "Hair transplant heading",
  "adm2.pc_dental_title": "Dental cosmetics title",
  "adm2.pc_dental_desc": "Dental cosmetics description",
  "adm2.pc_dental_heading": "Dental cosmetics heading",
  "adm2.pc_botox_title": "Botox & Filler title",
  "adm2.pc_botox_desc": "Botox & Filler description",
  "adm2.pc_botox_heading": "Botox & Filler heading",
  "adm2.pc_story_title": "Our story title",
  "adm2.pc_story_text": "Our story text",
  "adm2.pc_philosophy_title": "Philosophy title",
  "adm2.pc_philosophy_text": "Philosophy text",
  "adm2.pc_form_heading": "Form heading",
  "adm2.pc_ph_home_hero_title": "e.g. Your premium clinic in Tirana",
  "adm2.pc_ph_home_hero_sub": "e.g. High-quality treatments at fair prices...",
  "adm2.pc_ph_home_hero_cta": "e.g. Book an appointment now",
  "adm2.pc_ph_about_title": "e.g. About Esteva Clinic",
  "adm2.pc_ph_clinic_desc": "Description of the clinic...",
  "adm2.pc_ph_our_services": "e.g. Our services",
  "adm2.pc_ph_pricing_packages": "e.g. Our price packages",
  "adm2.pc_ph_testimonials": "e.g. What our clients say",
  "adm2.pc_ph_services_sub": "e.g. Discover our full range of treatments...",
  "adm2.pc_ph_hair": "e.g. Hair transplant",
  "adm2.pc_ph_dental": "e.g. Dental cosmetics",
  "adm2.pc_ph_botox": "e.g. Botox & Filler",
  "adm2.pc_ph_description": "Description...",
  "adm2.pc_ph_about_sub": "e.g. Your premium clinic in the heart of Tirana...",
  "adm2.pc_ph_our_story": "e.g. Our story",
  "adm2.pc_ph_clinic_story": "The story of the clinic...",
  "adm2.pc_ph_our_philosophy": "e.g. Our philosophy",
  "adm2.pc_ph_our_prices": "e.g. Our prices",
  "adm2.pc_ph_pricing_sub": "e.g. Transparent prices — up to 70% cheaper...",
  "adm2.pc_ph_gallery_title": "e.g. Before-after gallery",
  "adm2.pc_ph_gallery_sub": "e.g. Real results of our treatments...",
  "adm2.pc_ph_our_team": "e.g. Our team",
  "adm2.pc_ph_team_sub": "e.g. Get to know our experts...",
  "adm2.pc_ph_book_appt": "e.g. Book an appointment",
  "adm2.pc_ph_booking_sub": "e.g. Schedule your consultation now...",
  "adm2.pc_ph_your_data": "e.g. Your details",
  "adm2.pc_ph_contact": "e.g. Contact",
  "adm2.pc_ph_contact_sub": "e.g. How to reach us...",
  "adm2.edit_page_title": "Edit {{page}}",
  "adm2.manage_team_members": "Manage team members",
  "adm2.edit_pricing_treatments": "Edit price-list treatments",
  "adm2.saved_de_synced": "Saved! (DE → automatically applied to all languages) The changes are now live.",
  "adm2.saved_lang_live": "Saved! ({{lang}}) The changes are now live.",
  "adm2.changes_reset_for": "All changes for {{lang}} have been reset.",
  "adm2.lang_editor": "Language editor ({{lang}})",
  "adm2.lang_editor_de_note": "You are editing the DE version. Changes are automatically applied to all languages (EN, IT, ES, FR).",
  "adm2.lang_editor_other_note": "You are currently editing the {{lang}} version. Changes are saved separately for this language.",
  "adm2.texts": "Texts",
  "adm2.key_label": "Key:",
  "adm2.changed_original": "Changed — original:",
  "adm2.no_editable_fields": "No editable fields",
  "adm2.no_configured_fields": "This page has no configured fields yet.",
  "adm2.read_only": "Read only",
  "adm2.translations_info": "Translations are maintained directly in the language files. This page shows the current values for viewing. For changes, please contact your developer.",
  "adm2.pe_cat_dental": "Dentistry",
  "adm2.pe_cat_surgery": "Plastic surgery",
  "adm2.pe_cat_hair": "Hair transplant",
  "adm2.pe_new_treatment": "New treatment",
  "adm2.pe_default_stay": "Day hospital / 2 nights hotel (3 days)",
  "adm2.pe_category_reset": "All {{category}} treatments for {{lang}} have been reset.",
  "adm2.pe_confirm_reset_all": "Really reset ALL price lists in ALL languages? This action cannot be undone.",
  "adm2.pe_all_reset": "All price lists have been completely reset.",
  "adm2.pe_treatments_count": "{{count}} treatment(s)",
  "adm2.pe_edit_hint": "Edit name, price and optionally length of stay.",
  "adm2.pe_saved_lang": "Saved! ({{lang}})",
  "adm2.pe_treatment_name": "Treatment name",
  "adm2.pe_price_eur": "Price (€)",
  "adm2.pe_price_ph": "e.g. 350 – 400",
  "adm2.pe_stay": "Stay",
  "adm2.pe_stay_ph": "e.g. Day hospital / 2 nights hotel",
  "adm2.pe_no_treatments_lang": "No treatments in this language",
  "adm2.pe_no_treatments_hint": "Add a new treatment or reset to the default data.",
  "adm2.pe_add_treatment": "Add treatment",
  "adm2.pe_total_treatments": "Total: {{count}} treatments in {{lang}}",
  "adm2.pe_short_dental": "Dental",
  "adm2.pe_short_surgery": "Surgery",
  "adm2.pe_short_hair": "Hair",
  "adm2.tm_lang_de": "German",
  "adm2.tm_lang_it": "Italian",
  "adm2.tm_lang_en": "English",
  "adm2.tm_lang_fr": "French",
  "adm2.tm_lang_es": "Spanish",
  "adm2.tm_lang_nl": "Dutch",
  "adm2.tm_lang_pl": "Polish",
  "adm2.tm_lang_al": "Albanian",
  "adm2.tm_members_count": "Team members ({{count}})",
  "adm2.tm_add_member": "Add member",
  "adm2.tm_no_members": "No team members yet.",
  "adm2.tm_add_first_member": "Add first member",
  "adm2.tm_new_member": "New member",
  "adm2.tm_edit_member": "Edit member",
  "adm2.tm_profile_image": "Profile image",
  "adm2.tm_upload_image_max": "Upload image (max. 5 MB)",
  "adm2.tm_image_hint": "Square image recommended. Max. 5 MB.",
  "adm2.tm_name": "Name",
  "adm2.tm_name_ph": "e.g. Nertila Basha",
  "adm2.tm_title_position": "Title / Position",
  "adm2.tm_title_ph": "e.g. CEO, Dentist",
  "adm2.tm_specialty": "Specialty",
  "adm2.tm_specialty_ph": "e.g. Dental implants & aesthetic prosthetics",
  "adm2.tm_bio": "Biography",
  "adm2.tm_bio_ph": "Short biography of the team member...",
  "adm2.tm_languages": "Languages",
  "adm2.tm_certifications": "Certificates & qualifications",
  "adm2.tm_cert_ph": "Certificate {{num}}",
  "adm2.tm_add_cert": "Add certificate",
  "shared.chat_title": "Esteva Assistant",
  "shared.chat_online": "Online",
  "shared.chat_restart": "Restart",
  "shared.close": "Close",
  "shared.book_appointment": "Book appointment",
  "shared.chat_input_placeholder": "Write a message...",
  "shared.send": "Send",
  "shared.chat_close": "Close chat",
  "shared.chat_open": "Open chat",
  "shared.whatsapp_contact": "WhatsApp contact",
  "shared.whatsapp_tooltip": "Message us now on WhatsApp",
  "shared.select_language": "Select language",
  "shared.image": "Image",
  "shared.image_too_large": "File too large (max. 10 MB).",
  "shared.image_upload_failed": "Upload failed. Please try again.",
  "shared.image_uploading": "Uploading…",
  "shared.image_select": "Select image",
  "shared.image_url_placeholder": "or paste an image URL…",
  "shared.open_menu": "Open menu",
};

export default common;